import ExternalUtil from '../../../../ExternalUtil';
import UnifiedSignupScreenName from './UnifiedSignupScreenName';

export default class UnifiedSignupTemplateGetter {
  public static async getHtml({
    partialName,
  }: {
    partialName: UnifiedSignupScreenName
  }): Promise<HTMLDivElement> {
    // eslint-disable-next-line no-console
    console.log('Loading partial', partialName);
    const f = await fetch(`/${ExternalUtil.getSiteLang().toLocaleLowerCase()}/includes/signup-partials/${partialName}`);
    // Parsing the text response in a proper html.
    const node = ExternalUtil.stringToHTML(await f.text()) as HTMLDivElement;
    return node;
  }
}
